import { render, staticRenderFns } from "./stakeholderInternational.vue?vue&type=template&id=0b3e549f&scoped=true&"
import script from "./stakeholderInternational.vue?vue&type=script&lang=js&"
export * from "./stakeholderInternational.vue?vue&type=script&lang=js&"
import style0 from "./stakeholderInternational.vue?vue&type=style&index=0&id=0b3e549f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e549f",
  null
  
)

export default component.exports